module.exports = __webpack_public_path__ + "img/big.61f65f9f.jpg";